import script from "./StudentRatingItem.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentRatingItem.vue?vue&type=script&setup=true&lang=js"

import "./StudentRatingItem.vue?vue&type=style&index=0&id=1577e97f&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1577e97f"]])

export default __exports__